import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, Phone, Mail, MapPin } from "lucide-react";
import Logo from "../../../assets/images/logo.png";
import "./Footer.css";
import {
  FaGooglePlay,
  FaApple,
} from "react-icons/fa";

const QUICK_LINKS = [
  { to: "/",               label: "Home" },
  { to: "/property-list",  label: "Properties" },
  { to: "/interiordesign", label: "Interior Design" },
  { to: "/about-us",       label: "About Us" },
  { to: "/contactus",      label: "Contact Us" },
  // { to: "/partnerreg",     label: "Become a Partner" },
];

const LEGAL_LINKS = [
  { to: "/policy", label: "Privacy Policy" },
  { to: "/policy", label: "Terms & Conditions" },
];

const SOCIALS = [
  { href: "https://www.facebook.com/allhomedesire/",                               icon: Facebook,  label: "Facebook" },
  { href: "https://www.instagram.com/allhomedesire/",                              icon: Instagram, label: "Instagram" },
  { href: "https://x.com/ushmainfotech",                                           icon: Twitter,   label: "Twitter" },
  { href: "https://www.linkedin.com/company/ushma-infotech/posts/?feedView=all",   icon: Linkedin,  label: "LinkedIn" },
];

const CONTACT = [
  { icon: MapPin, text: "7th Avenue Gaur City 1, Noida Extension" },
  { icon: Phone,  text: "+91 9818961783" },
  { icon: Mail,   text: "support@allhomedesire.com" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">

        <div className="footer__top">

          <div className="footer__col">
            <img src={Logo} alt="All Home Desire" className="footer__logo" />
            <p className="footer__tagline">
              Helping you find the perfect space — effortlessly, transparently,
              and tailored to the way you want to live.
            </p>
            <div className="footer__store-btns">
              <a href="#" className="footer__store-btn">
                <span className="footer__store-btn-icon"><FaGooglePlay /></span>
                <span className="footer__store-btn-text">
                  <span className="footer__store-btn-sub">Get it on</span>
                  <span className="footer__store-btn-name">Google Play</span>
                </span>
              </a>
              <a href="#" className="footer__store-btn">
                <span className="footer__store-btn-icon"><FaApple /></span>
                <span className="footer__store-btn-text">
                  <span className="footer__store-btn-sub">Download on</span>
                  <span className="footer__store-btn-name">App Store</span>
                </span>
              </a>
            </div>
          </div>

          <div className="footer__col">
            <span className="footer__col-heading">Quick Links</span>
            <ul className="footer__link-list">
              {QUICK_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <span className="footer__col-heading">Contact</span>
            <ul className="footer__contact-list">
              {CONTACT.map(({ icon: Icon, text }) => (
                <li key={text} className="footer__contact-item">
                  <Icon size={14} className="footer__contact-icon" />
                  {text}
                </li>
              ))}
            </ul>
            <div className="footer__socials">
              {SOCIALS.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  className="footer__social-btn"
                  aria-label={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="footer__col">
            <span className="footer__col-heading">Legal</span>
            <ul className="footer__link-list">
              {LEGAL_LINKS.map(({ to, label }) => (
                <li key={label}>
                  <Link to={to} className="footer__link">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="footer__bottom">
          <p className="footer__copy">
            © {currentYear} <span>allhomedesire</span>. All rights reserved.
          </p>
          <div className="footer__legal">
            {LEGAL_LINKS.map(({ to, label }, i) => (
              <React.Fragment key={label}>
                {i > 0 && <span className="footer__legal-dot" />}
                <Link to={to} className="footer__legal-link">{label}</Link>
              </React.Fragment>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;